import axios from 'axios';
import Cookies from 'js-cookie';

import { API_URL } from 'constants'

export function getEvents() {
  return axios.get(`${API_URL}/api/v1/events.json`, { withCredentials: true })
    .then(response => response.data)
    .catch((response) => {
      console.log(response);

      return [];
    })
}

export function getEvent(id) {
  return axios.get(`${API_URL}/api/v1/events/${id}.json`, { withCredentials: true })
    .then(response => response.data)
    .catch((response) => {
      console.log(response);

      return [];
    })
}

export function createEvent(params) {
  const token = Cookies.get('csrf_token');

  return axios.post(`${API_URL}/api/v1/events.json`, params, { headers: { 'X-CSRF-TOKEN': token }, withCredentials: true })
    .then(response => response.data)
    .catch((response) => {
      console.log(response);

      return response;
    })
}

export function updateEvent(id, params) {
  const token = Cookies.get('csrf_token');

  return axios.put(`${API_URL}/api/v1/events/${id}.json`, params, { headers: { 'X-CSRF-TOKEN': token }, withCredentials: true })
    .then(response => response.data)
    .catch((response) => {
      console.log(response);

      return response;
    })
}
